import React, { useState } from 'react'

import pluralize from 'pluralize'

import { Box, Grow, useMediaQuery } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import SimpleCard from '~/components/cards/SimpleCard'
import ProductCalculateForm from '~/components/forms/ProductCalculateForm'
import ExtendedButton from '~/components/shared/ExtendedButton'
import Flexbox from '~/components/shared/Flexbox'
import Text, { Title } from '~/components/shared/Text'

import { formatCurrency } from '~/utils/functions'

import { Theme } from '~/theme/theme'

import { getEntityByBrand } from '~/brands'

const src = getEntityByBrand<string>({
  rv:
    'https://www.creditone.com.au/quick-quote?dealer_name=trade-rvs&utm_source=website-calculator&utm_medium=referral&utm_campaign=dealer_application_form&utm_keywords=quick-quote',
  boat:
    'https://www.creditone.com.au/quick-quote?dealer_name=trade-a-boat&utm_source=website-calculator&utm_medium=referral&utm_campaign=dealer_application_form&utm_keywords=quick-quote'
})

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      estimateField: {
        backgroundColor: '#EBF2F8',
        flexDirection: 'column',
        alignItems: 'center'
      },
      applyBtn: {
        minWidth: '285px',
        fontWeight: 400,
        [theme.breakpoints.down('sm')]: {
          fontWeight: 600
        },
        fontSize: '16px'
      }
    }),
  { name: 'FinanceSection' }
)

const FinanceSection: React.FC<{
  type: string
  price: number
  loading?: boolean
}> = ({ type, price, loading }) => {
  const [repaymentData, setRepaymentData] = useState({
    pay: null,
    frequency: null
  })
  const classes = useStyles()
  const isMobile = useMediaQuery('(max-width: 600px)')

  // const [showCalculatorForm, closeCalculatorForm] = useModal(
  //   (props) => (
  //     <CreditOneDialog
  //       {...props}
  //       price={`$${IntlService.numberFormat(repayment)}`}
  //       onClose={closeCalculatorForm}
  //     />
  //   ),
  //   [repayment]
  // )

  return (
    <SimpleCard width="100%" mb={3}>
      <Box style={{ opacity: loading ? '0.5' : 1 }}>
        <Title variant="h2" fontSize={20} mt={0} mb={2}>
          Want to Finance this {type ? pluralize.singular(type) : 'vehicle'}?
        </Title>
        <Text color="primary" fontWeight={600} mb={1}>
          REPAYMENT CALCULATOR
        </Text>
        <Text mb={4} fontSize={14}>
          This calculator is provided as a guide and for estimation purposes
          only.
          <br />
          Change any value to suit your needs.
        </Text>
      </Box>
      <ProductCalculateForm
        setRepayment={setRepaymentData}
        loading={loading}
        price={price}
      />
      <Grow
        mountOnEnter
        unmountOnExit
        in={!!repaymentData.pay || repaymentData.pay === 0}
      >
        <Flexbox mt={3} p={isMobile ? 1 : 3} className={classes.estimateField}>
          <Text fontSize={14} fontWeight={600} mb={2}>
            Your estimated {repaymentData.frequency} repayments
          </Text>
          <Title fontSize={25}>{formatCurrency(repaymentData.pay)}</Title>
          <a
            href={src}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <ExtendedButton
              size="large"
              mx="auto"
              mt={2}
              mb={1}
              fullWidth={isMobile}
              className={classes.applyBtn}
            >
              Get a quote
            </ExtendedButton>
          </a>

          <Text fontSize={12} color="textSecondary" textAlign="center" mb={1.5}>
            Getting a finance quote won’t affect your credit score
          </Text>
        </Flexbox>
      </Grow>
    </SimpleCard>
  )
}

export default React.memo(FinanceSection)
